import { Wallet, getRouterProvider, walletTools } from '@halo/wallet-app';
import { router } from './router';
import { useWalletStore } from './store';

const routerRoot = getRouterProvider({ router });

export function WalletApp() {
  const store = useWalletStore();

  useEffect(() => {
    if (store.activeTrigger) {
      walletTools.showWalletApp();
    }
  }, [store.activeTrigger]);

  return <Wallet store={store}>{routerRoot}</Wallet>;
}
